<script>

export default {
    name: 'spotify-lineup',
    props: {
		selectedTimeOption: String,
		initialImageUrl: String,
		initialIgStoryUrl: String,
		initialShareUrl: String,
		topTexts: String,
		bottomTexts: String,
		initialError: String,
		ajaxUrl: String,
	},
    data: function() {
        return {
        	loading: false,
			time_option: this.selectedTimeOption,
			image_url: this.initialImageUrl,
			ig_story_url: this.initialIgStoryUrl,
			share_url: this.initialShareUrl,
			top_texts: JSON.parse(this.topTexts),
			bottom_texts: JSON.parse(this.bottomTexts),
			error: this.initialError,
			ajax_url: this.ajaxUrl,
        }
    },


    mounted: function() {

    },


	methods: {
		selectTimeOption: function(time_option) {
			if (this.time_option === time_option) return;

			this.loading = true;
			this.time_option = time_option;
			this.fetchImageData();
		},

		fetchImageData: function() {
			let _self = this;

			jQuery.post(_self.ajax_url, {
				action: 'spotify_lineup_get_image_data',
				time_range: _self.time_option,
				top_texts: JSON.stringify(_self.top_texts),
				bottom_texts: JSON.stringify(_self.bottom_texts),
			}, function(data) {
				data = JSON.parse(data);
				_self.error = data.error;
				_self.image_url = data.image_url;
				_self.ig_story_url = data.ig_story_url;
				_self.share_url = data.share_url;
				if (_self.share_url) {
					_self.share_url = window.location.toString()+_self.share_url;
				}

				if (_self.error) {
					_self.loading = false;
				}
			});
		},

		imageLoaded: function() {
			this.loading = false;
		}
	}

};

</script>